import { CoBom } from "../co-bom.entity";
import { CoBomDto } from "./co-bom.dto";



export class CoBomAdapter{
    // convertDtoToEntity(dtoobj:CoBomDto,isUpdate: boolean = false ):CoBom{
    //     try{
    //         const entityObj = new CoBom();
    //         entityObj.coLineNumber=dtoobj.coLineNumber
    //         entityObj.coNumber=dtoobj.coNumber
    //         entityObj.fgItemBomId=dtoobj.fgItemBomId
    //         entityObj.fgSku=dtoobj.fgSku
    //         entityObj.orderId=dtoobj.orderId
    //         entityObj.quantity=dtoobj.quantity
    //         entityObj.
    //         entityObj.versionFlag = dtoobj.versionFlag
    //         if (isUpdate) {
    //             entityObj.updatedUser = dtoobj.createdUser;
    //           } else {
    //             entityObj.isActive = true;
    //             entityObj.createdUser = dtoobj.createdUser;
    //           }
    //      return dtoobj;
    //     }catch(Error){
    //         throw  Error;
    //     }

    
}